import {useEffect} from "react";

export function useClickOutside(refs, onOutsideClick, active) {
    useEffect(() => {
        const handleClickOutside = (event) => {
            const clickedInside = refs.some(
                (ref) => ref.current && ref.current.contains(event.target),
            );
            if (!clickedInside) {
                onOutsideClick();
            }
        };

        if (active) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [active, refs, onOutsideClick]);
}
